import { IUserService } from '_c/typings/service/user-service';
import { injectable } from '_c/business/service';
import { useStore } from '@/store';
import { md5 } from '_c/util/crypto';


@injectable()
export class UserService implements IUserService {
  getUserId(): string {
    const store = useStore();
    const { loginInfo } = store.state.login;
    return loginInfo?.uid ?? '';
  }

  getUploadPrefix(): string {
    const store = useStore();
    const { loginInfo } = store.state.login;
    return md5(loginInfo?.luUid ?? '');
  }
}
